/* eslint-disable */
import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import Maindail from './Maindail';
import CommonClass from '../../js/common';
import {
    HOME_PAGE_UNLOADED
} from '../../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.home,
    appName: state.common.appName,
    token: state.common.token
});

const mapDispatchToProps = dispatch => ({
    onUnload: () =>
        dispatch({ type: HOME_PAGE_UNLOADED })
});


class Home extends React.Component {
    componentWillMount() {
    }

    componentDidMount() {
    }
    componentDidLeave() {

    }
    componentWillUnmount() {

        this.props.onUnload();
    }

    render() {
        return (
            <div>
                <div className="main-dots border-right-left">
                    <img id="CircuitRight" src={CommonClass.cdn_url + "images/CircuitRight.svg"} className="circuit-lines-right" />
                    <img id="CircuitLeft" src={CommonClass.cdn_url + "images/CircuitLeft.svg"} className="circuit-lines-left" />
                </div>

                <div className="content-resize-container" id="MainContainer">
                    <Maindail />
                </div>

            </div >
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);




// WEBPACK FOOTER //
// src/components/Home/Index.js